<template>
  <li class="cart-item">
    <dl>
      <dt class="stitle2 tleft">
        <p class="checkbox">
          <input type="checkbox" :id="cartItem.cartNo + 'chk1'" v-model="cartItem.checked" />
          <label :for="cartItem.cartNo + 'chk1'">{{ cartItem.mrktnPdNm }}</label>
        </p>
        <strong class="titdate">{{ cartItem.expVisitRvdt }}</strong>
      </dt>
      <dd class="colorBox">
        <ul class="listBox">
          <li>
            <strong>회차</strong>
            <span>{{ cartItem.mrktnScheSeqNm }}({{ cartItem.scheTime }})</span>
          </li>
          <li class="wdful">
            <strong>인원</strong>
            <span>
              <i v-if="cartItem.includeList.length > 0">체험자 {{ includePcnt }}명</i>
              <i v-if="cartItem.leaderList.length > 0">인솔자 {{ cartItem.leaderList.length }}명</i>
            </span>
          </li>
          <li>
            <strong>상품 금액</strong>
            <span>{{ _wonFormat(originPrice) }}</span>
          </li>
          <li>
            <strong>할인 금액</strong>
            <span>{{ _wonFormat(dcPrice) }}</span>
          </li>
          <li>
            <strong>결제 금액</strong>
            <span>{{ _wonFormat(totPrice) }}</span>
          </li>
        </ul>
      </dd>
    </dl>
  </li>
</template>

<script>
import { groupBy } from 'lodash';

export default {
  name: 'CartListItem',
  props: ['cartItem'],
  computed: {
    includePcnt() {
      const grouped = groupBy(this.cartItem.includeList, 'groupKey');
      return Object.values(grouped).reduce((a, e) => e[0].pcnt + a, 0);
    },
    originPrice() {
      return this.cartItem.originPrice;
    },
    dcPrice() {
      return this.cartItem.originPrice - this.cartItem.saleAmt;
    },
    totPrice() {
      return this.cartItem.saleAmt;
    },
  },
  methods: {},
};
</script>
